
import RecommendedBox from "./RecommendedBox";

export default function RPreview() {
    return (
        <div className={`w-full h-full `}>
            <RecommendedBox />
        </div>
    );
}
